import { Link } from 'react-router-dom'
import Logout from "./Logout";

const Navbar= ({ groups }) => {
    // Check if we're in development environment - try both REACT_APP_ENVIRONMENT and NODE_ENV
    const isDevelopment = process.env.REACT_APP_ENVIRONMENT === 'development' || process.env.NODE_ENV === 'development';
    
    // Debug logging
    console.log('Environment check:', {
        REACT_APP_ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
        NODE_ENV: process.env.NODE_ENV,
        isDevelopment: isDevelopment
    });
    
    // Set navbar classes based on environment
    const navbarClasses = isDevelopment 
        ? "navbar navbar-expand-lg bg-success"
        : "navbar navbar-expand-lg bg-body-tertiary";
    
    return(
        <nav className={navbarClasses} data-bs-theme="dark">
        <div className="container-fluid">
          <Link className="navbar-brand" to="/">
            <img src="/mtkd-logo.png" alt="MTKD" width="120" height="32" class="d-inline-block align-text-top"/> 
          </Link>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarText">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link className="nav-link" to="/students">Students</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/attendance">Attendance</Link>
              </li>
              {groups.includes("mtkd-finance") && (
                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    Financials
                  </a>
                  <ul className="dropdown-menu">
                    <li><Link className="dropdown-item" to="/record-payments">Record Payments</Link></li>
                    <li><Link className="dropdown-item" to="/payment-history">Payment History</Link></li>
                  </ul>
                </li>
              )}
              {groups.includes("mtkd-admin") && (
                <>
                  <li className="nav-item">
                    <Link className="nav-link" to="/promotions">Promotions</Link>
                  </li>
                  <li className="nav-item dropdown">
                    <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                      Events
                    </a>
                    <ul className="dropdown-menu">
                      <li><Link className="dropdown-item" to="/create-event">Create Event</Link></li>
                      <li><Link className="dropdown-item" to="/register-students">Register Students</Link></li>
                      <li><Link className="dropdown-item" to="/event-details">Event Details</Link></li>
                    </ul>
                  </li>
                  <li className="nav-item dropdown">
                    <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                      Maintenance
                    </a>
                    <ul className="dropdown-menu">
                      <li><Link className="dropdown-item" to="/classes">Classes</Link></li>
                      <li><Link className="dropdown-item" to="/student-roles">Student Roles</Link></li>
                      <li><Link className="dropdown-item" to="/image-maintenance">Images</Link></li>
                      {groups.includes("mtkd-finance") && (
                        <li><Link className="dropdown-item" to="/debt-types">Debt Types</Link></li>
                      )}
                    </ul>
                  </li>
                </>
              )}
            </ul>
            <ul className="navbar-nav ms-auto">
              <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                  <i className="bi bi-person-circle me-1"></i>
                  Account
                </a>
                <ul className="dropdown-menu dropdown-menu-end">
                  <li><Link className="dropdown-item" to="/change-password">Change Password</Link></li>
                  <li><hr className="dropdown-divider" /></li>
                  <li><Logout /></li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    )
}

export default Navbar